<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDCE48"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDCE48" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #000">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left>
        <span class="itemHeading"> Change Password </span>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center py-4>
      <v-flex xs12 lg10>
        <v-layout wrap justify-start>
          <v-flex xs12 text-left px-2>
            <span class="itemValue">Current Password</span>
            <v-text-field
              ref="password"
              color="#FDCE48"
              placeholder="••••••••"
              type="password"
              dense
              v-model="oldPassword"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 text-left px-2>
            <span class="itemValue">New Password</span>
            <v-text-field
              ref="lastname"
              color="#FDCE48"
              placeholder="••••••••"
              type="password"
              dense
              v-model="password"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 sm6 xl3 pa-2>
        <v-btn
          block
          tile
          outlined
          color="#FF1313"
          light
          :ripple="false"
          depressed
          @click="closeDialoge"
          class="itemValue"
        >
          Cancel
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 xl3 pa-2>
        <v-btn
          block
          tile
          color="#FDCE48"
          light
          :ripple="false"
          depressed
          @click="validateInput"
          class="itemValue"
        >
          Change Password
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      password: null,
      oldPassword: null,
    };
  },
  methods: {
    closeDialoge() {
      this.$emit("stepper", {
        type: "Password",
        getData: false,
        changePassword: false,
        status: false,
      });
    },
    validateInput() {
      if (!this.oldPassword) {
        this.msg = "Please Provide Current Password";
        this.showSnackBar = true;
        return;
      } else if (!this.password) {
        this.msg = "Please Provide New Password";
        this.showSnackBar = true;
        return;
      } else {
        this.changePassword();
      }
    },
    changePassword() {
      var userData = {};
      userData["password"] = this.password;
      userData["oldpassword"] = this.oldPassword;
      axios({
        method: "post",
        url: "/user/Edit",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$emit("stepper", {
              type: "Password",
              getData: false,
              changePassword: false,
              status: true,
            });
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;
        });
    },
  },
};
</script>